export default "__VITE_ASSET__915400f9__"